import { render, staticRenderFns } from "./TaskRunStatusDot.vue?vue&type=template&id=2ec2987c&scoped=true"
import script from "./TaskRunStatusDot.vue?vue&type=script&lang=js"
export * from "./TaskRunStatusDot.vue?vue&type=script&lang=js"
import style0 from "./TaskRunStatusDot.vue?vue&type=style&index=0&id=2ec2987c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2987c",
  null
  
)

export default component.exports